import { AIRPORT_TO_STORE_NAME, TERMINAL_OVERRIDES } from '../constants/wpStoreMapping'
import { parseWpHandoffParams } from './embedContext'

function normalizeStoreName (value) {
  return String(value || '').trim().toLowerCase()
}

function mergeHandoff (overrides) {
  var base = parseWpHandoffParams()
  if (!overrides) return base

  return {
    country: String(overrides.country || base.country || '').toUpperCase(),
    airport: String(overrides.airport || base.airport || '').toUpperCase(),
    terminal: String(overrides.terminal || base.terminal || '').toUpperCase(),
    service: String(overrides.service || base.service || '').toLowerCase()
  }
}

export function resolveStoreIdFromWpParams (stores, params) {
  var list = Array.isArray(stores) ? stores : []
  if (!list.length) return null

  var handoff = mergeHandoff(params)
  if (!handoff || !handoff.airport) return null

  var overrideKey = handoff.terminal ? handoff.airport + ':' + handoff.terminal : null
  var targetName = (overrideKey && TERMINAL_OVERRIDES[overrideKey]) || AIRPORT_TO_STORE_NAME[handoff.airport]
  if (!targetName) return null

  var exact = list.find(function (store) {
    return normalizeStoreName(store.name) === normalizeStoreName(targetName)
  })
  if (exact) return Number(exact.id)

  var partial = list.find(function (store) {
    var name = normalizeStoreName(store.name)
    if (handoff.airport === 'SYD') return name.indexOf('sydney') >= 0
    if (handoff.airport === 'MEL') return name.indexOf('melbourne') >= 0
    if (handoff.airport === 'AKL') return name.indexOf('auckland') >= 0
    return false
  })

  return partial ? Number(partial.id) : null
}



// WEBPACK FOOTER //
// ./src/utils/wpStoreResolver.js